/*STICKY HEADER on scroll*/
(function () {
    $(document).ready(function () {

        /*STICKY HEADER on desktop*/
        var headerSecond = document.querySelector(".a-header.a-header_second");
        var stickyTop_forDesktop = headerSecond.offsetTop;
        var body = document.querySelector("body");

        /*В desktop header прилипает при скролле и виден всегда*/
        function stickyHeaderOnScroll_desktop() {
            if (window.pageYOffset >= stickyTop_forDesktop) {
                body.classList.add("sticky-header");
                headerSecond.classList.add("sticky");
            } else {
                headerSecond.classList.remove("sticky");
                body.classList.remove("sticky-header");
            }
        }

        /*STICKY HEADER on mobile*/
        // Объявление переменных
        var $headerFirst = $(".a-header.a-header_first");
        var lastScrollTop = 0; // Переменная для хранения предыдущей позиции скролла
        var $body = $("body");

        // Функция, осуществляющая прикрепление шапки при прокрутке страницы
        /*В mobile header скрывается при прокрутке вниз страницы, и появляется и прокрутке вверх страницы*/
        function stickyHeaderOnScroll_mobile() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop < lastScrollTop && scrollTop > $headerFirst.outerHeight()) {
                $body.delay(800).addClass("sticky-header");
                $headerFirst.delay(800).addClass("sticky");
            } else {
                $headerFirst.delay(800).removeClass("sticky");
                $body.delay(800).removeClass("sticky-header");
            }
            lastScrollTop = scrollTop;
        }

        // Вызов функций при скролле страницы
        if ($(window).width() > 992) {
            window.onscroll = function() {
                stickyHeaderOnScroll_desktop();
            };
        } else {
            $(window).scroll(function () {
                stickyHeaderOnScroll_mobile();
            });
        }
    });
})();

/*open log-in dropdown menu*/
/*OLD DROPDOWN*/
/*todo backend - удалить после внедрения нового выпадающего меню пользователя*/
/*(function($, window, document) {
    $(document).ready(function() {
        var $lkDropdownWrap = $('.lk-dropdown-wrap');
        var $logIn = $('.log-in');

        if ($lkDropdownWrap.length === 0) {
            return
        }

        var $lkDropdown = $('.lk-dropdown');
        var mobileWidth = 670;

        $lkDropdownWrap.bind('mouseenter', function() {
            if (window.innerWidth > mobileWidth) {
                if (!$lkDropdown.hasClass('active')) {
                    $lkDropdown.addClass('active');
                    $('body').addClass('lk-dropdown-active')
                }
            }
        }).bind('mouseleave', function() {
            if (window.innerWidth > mobileWidth) {
                if ($lkDropdown.hasClass('active')) {
                    $lkDropdown.removeClass('active');
                    $('body').removeClass('lk-dropdown-active')
                }
            }
        });

        $logIn.bind('click', function(e) {
            if (window.innerWidth <= mobileWidth) {
                e.preventDefault();
                $lkDropdown.addClass('active');
                $('body').addClass('lk-dropdown-active')
            }
        });

        $('.lk-dropdown-close').bind('click', function() {
            $lkDropdown.removeClass('active');
            $('body').removeClass('lk-dropdown-active')
        });

        var lastSizeWasMobile = window.innerWidth <= mobileWidth;
        $(window).bind('resize', function() {
            var sizeIsMobile = window.innerWidth <= mobileWidth;

            if (lastSizeWasMobile !== sizeIsMobile) {
                if ($lkDropdown.hasClass('active')) {
                    $lkDropdown.removeClass('active');
                    $('body').removeClass('lk-dropdown-active')
                }
            }
        });
    });
})(jQuery, window, document);
*/
